import React, { useEffect, useState } from 'react'
import { PageHeader } from '../../../../common'
import { useNavigationContext } from '../../../../context/NavigationContext';
import { useDashboardTeamContext } from '../../../../context/DashboardTeamContext';
import TeamSales from './TeamSales';
import TeamShop from './TeamShop';
import TeamPayoff from './TeamPayoff';
import { Booklet } from '../../../../types/generated.types';

export default function DashboardTeamHome() {
  const { associationData, teamData, associationBooklets, defaultBooklet, refetchTeam } = useDashboardTeamContext();
  const { setNavigationActivated } = useNavigationContext();

  const [selectedBooklet, setSelectedBooklet] = useState<Booklet | undefined>(undefined);

  useEffect(() => {
    setNavigationActivated(true);
  }, [setNavigationActivated]);

  // Set default booklet when data becomes available
  useEffect(() => {
    if (defaultBooklet && !selectedBooklet) {
      setSelectedBooklet(defaultBooklet);
    }
  }, [defaultBooklet, selectedBooklet]);

  return (
    <div id="dashboard" className='start'>
      <PageHeader>
        <h1>Hej {teamData?.name}!</h1>
        <p>Välkommen till Mina sidor</p>
      </PageHeader>
      {associationData && teamData && (
        <TeamShop
          association={associationData}
          team={teamData}
          refetchTeam={refetchTeam}
        />
      )}
      {teamData && (
        <TeamSales
          team={teamData}
          associationBooklets={associationBooklets}
          selectedBooklet={selectedBooklet}
          onBookletChange={setSelectedBooklet}
        />
      )}
      {teamData && (
        <TeamPayoff
          team={teamData}
          selectedBooklet={selectedBooklet}
        />
      )}
    </div>
  )
}
